// extracted by mini-css-extract-plugin
export var progressBar = "_ig-0";
export var progressBarInner = "_ig-1";